import React, { useEffect, useState } from 'react';
import { Row, Col, Popover, OverlayTrigger } from "react-bootstrap";
import { NotificationManager } from 'react-notifications';
import Select from 'react-select';
import CKEditor from 'ckeditor4-react';

import CustomModal from "../../components/Modal/CustomModal";

import { SearchCorreos, addAttachment, iconos, formatBytes, sendNewMail } from '../../funciones/EmailFunction';

CKEditor.editorUrl = 'ckeditor/ckeditor.js';

const NewEmail = (props) => {
    const [correos, setCorreos] = useState([]);
    const [destEmail, setDestEmail] = useState("");
    const [asunto, setAsunto] = useState("");
    const [control, setControl] = useState(false);
    const [correosLoad, setCorreosLoad] = useState(true);
    const [destinatarios, setDestinatarios] = useState([]);
    const [contentState, setContentState] = useState("");
    const [boton1, setBoton1] = useState({ icon: "fa fa-send", text: "Enviar", disabled: false });
    const [boton2, setBoton2] = useState({ icon: "fa fa-paperclip", text: "Adjuntar Archivo" });
    const [correosSelect, setCorreosSelect] = useState(props.remitente);
    const [attFileName, setAttFileName] = useState([]);
    const [tam, setTam] = useState(0);
    const [openModalConfirm, setOpenModalConfirm] = useState(false);
    /* const [attachementsId, setAttachementsId] = useState([]); */

    useEffect(() => {
        SearchCorreos ((resp) => { setCorreos (resp) })
    }, []);

    useEffect(() => {
        setCorreosLoad(false)
    }, [correos]);

    useEffect(() => {
        setCorreosSelect(props.remitente)
    }, [props.remitente]);

    let styles2 = {
        paddingRight: 15,
        cursor: "pointer",
        fontSize: 16,
        color: "f6a72f"
    }

    const configuraciones = {
        toolbar: [
            [ 'Font', 'FontSize', '-', 'Copy', 'Paste', 'PasteText', '-', 'Undo', 'Redo', '-', 'Bold', 'Italic', 'Underline', '-', 'TextColor', 'BGColor', '-', 'Link', 'Maximize' ],
        ],
        height: "21vh",
        removePlugins: 'elementspath',
        /* removePlugins: 'resize, elementspath', */
    }

    let cambiaHtml = (e) => {
        setContentState(e.editor.getData())
    }

    let cambiaCorreo = (correosSelect) => {
        setCorreosSelect(correosSelect)
    }

    let remitente = () => {
        if (correosSelect.value === "") return "No has seleccionado un correo"
        return <span>De: <strong>{correosSelect.label}</strong></span>
    }

    let tipoDest = (tipo) => {
        switch (tipo) {
            case "D": return null
            case "C": return "CC: "
            case "CO": return "CCO: "
        }
    }

    let para = () => {
        if (destinatarios.length === 0 ) return (
            <div className="text-muted">Sin Destinatarios</div>
        )
        
        let borrar = (email) => {
            let contenido = destinatarios;

            for (let i in destinatarios){
                if (destinatarios[i].email === email) contenido.splice(i, 1)
            }

            setDestinatarios(contenido)
            setControl(!control)
        }

        return (
            destinatarios.map(option => (
                <span key = {(Math.random() * 999999) + 1} className="tagsinput" style={{backgroundColor: option.color}}>{tipoDest(option.tipo)}{option.email} <i className="fa fa-times" onClick={() => {borrar(option.email)}} title="Eliminar" style={{cursor: "pointer"}}></i></span>
            ))
        )
    }

    let addDestinatario = (e) => {
        if (e.which === 13){
            let string = (e.target.value).trim();
            if (string === "") return null;

            const resultado = destinatarios.find( item => item.email === e.target.value );
            if (resultado === undefined){
                let contenido = destinatarios;
                let expReg = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;
                (expReg.test(string) === false) ? contenido.push({ tipo:"D", email: destEmail, color: "cb0b0b"}) : contenido.push({ tipo:"D", email: destEmail, color: "6c7c9c"});
                
                setDestinatarios(contenido)
            }

            setControl(!control)
            setDestEmail("")
        }
    }

    let addOtDestinatario = (tipoD) => () => {
        let string = (destEmail).trim();
        if (string === "") return null;
        
        let contenido = destinatarios;
        let expReg = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;
        (expReg.test(string) === false) ? contenido.push({ tipo: tipoD, email: destEmail, color: "cb0b0b"}) : contenido.push({ tipo: tipoD, email: destEmail, color: "6c7c9c"});
        
        setDestinatarios(contenido)
        setControl(!control)
        setDestEmail("")
    }

    let addAttState = (item) => {
        let contenido = attFileName;
        contenido.push(item)

        setTam(tam + item[2])
        setAttFileName(contenido)
        setControl(!control)
    }

    let delAttachment = (adj) => {
        let contenido = attFileName;
        let size = 0;
        for (let i in attFileName){
            if (adj === attFileName[i][3]) contenido.splice(i, 1)
            if (attFileName[i] !== undefined) size += attFileName[i][2]
        }

        let file = document.getElementById(adj);
        if (file) {
            (file.parentNode).removeChild(file);
        }
        
        setTam(size)
        setAttFileName(contenido)
        setControl(!control)
    }

    let adjuntos = () => {
        if (attFileName.length === 0) return (
            <div align="center" className="text-muted" style={{fontSize: 11}}>Ningún archivo</div>
        )
        
        return attFileName.map(option => (
            <div key = {(Math.random() * 999999) + 1} className="attachment-file" style={{fontSize: 10, marginTop: 4, cursor: "default"}}>
                <i className={iconos(option[1].toUpperCase(), "icono")} style={{color: iconos(option[1].toUpperCase(), "color")}}></i> {option[0]}
                <div className="text-muted" align="right">({formatBytes(option[2])}) <i className="fa fa-trash text-danger" style={{fontSize: 12, cursor: "pointer"}} onClick={() => {delAttachment(option[3])}} title="Quitar este archivo"></i></div>
            </div>
        ))
    }

    let tipos = (
        <Popover id="tipos">
            <div className="new-mail-item" onClick={addOtDestinatario("D")}>Destinatario</div>
            <div className="new-mail-item" onClick={addOtDestinatario("C")}>CC</div>
            <div className="new-mail-item" onClick={addOtDestinatario("CO")}>CCO</div>
        </Popover>
    )

    let contenidoMail = () => (
        <Row>
            <Col md={6}>
                <span className="text-muted" style={{fontSize: 10}}>Para:</span>
                <div className="input-group">
                    <input type="text" className="form-control" onChange={(e)=> {setDestEmail((e.target.value).trim())}} value={destEmail}
                    onKeyPress={ addDestinatario } title="Presiona ENTER para añadir un nuevo destinatario" placeholder="Para"/>
                    <div className="input-group-btn">
                        <OverlayTrigger trigger="focus" placement="bottom" overlay={tipos}>
                            <button className="btn btn-default" title="Agregar como" style={{height: 40}}><i className="fa fa-plus" style={{color: "005d9b"}}></i></button>
                        </OverlayTrigger>
                    </div>
                </div>
            </Col>
            <Col md={6}>
                <span className="text-muted" style={{fontSize: 10}}>Asunto:</span>
                <input type="text" className="form-control" placeholder="Asunto" value={asunto} onChange={(e) => {setAsunto(e.target.value)}}/>
            </Col>
            <Col md={12} className="custom-mt-10" style={{backgroundColor:"f2f4f8", overflowX:"hidden", overflowY: "auto", height: "8vh", padding: 5}}>
                {para()}
            </Col>
            <Col md={12} style={{padding: 6, paddingTop: 3}}>
                <div className="new-mail-body">
                    <CKEditor
                        data = {contentState}
                        type = "classic"
                        onChange = {cambiaHtml} 
                        config = {configuraciones}
                    />
                </div>
            </Col>
        </Row>
    )

    let respSend = (resp) => {
        
        NotificationManager[resp.tipo](resp.text);
        if (resp.tipo === "info") {
            document.getElementById("attachments").innerHTML = "";
            setDestinatarios([])
            setDestEmail("")
            setAsunto("")
            setContentState("")
            setAttFileName([])
            setTam(0)
        }
        setBoton1({icon: "fa fa-send", text: "Enviar", disabled: false})
    }

    let sendMess = () => {
        if (boton1.disabled === true) return null;

        if (destEmail === "" && destinatarios.length === 0){
            NotificationManager.error("Debes tener al menos un destinatario");
            return null;
        }

        if (contentState === "" && asunto === ""){
            setOpenModalConfirm(true)
        }else{
            /* Agregar los adjuntos */
            let adjuntos = []
            attFileName.map(file => {
                adjuntos.push(document.getElementById(file[3]))
            })

            setBoton1({icon: "fa fa-spinner fa-spin", text: "Enviando", disabled: true})
            sendNewMail (adjuntos, correosSelect.value, destEmail, destinatarios, asunto, contentState, (resp) => {respSend(resp)})
        }
    }

    let modalConfirm = () => (
        <CustomModal
            boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
            boton1 = {<React.Fragment><i className="fa fa-check"></i> Si</React.Fragment>}
            large = "medium"
            isopen =  {openModalConfirm}
            titulo = "Confirmación"
            contenido = {<div>¿Deseas enviar el mensaje <strong className="text-danger">Sin asunto ni texto en el cuerpo</strong>?</div>}      
            funcion1 = {() => {
                /* Agregar los adjuntos */
                let adjuntos = []
                attFileName.map(file => {
                    adjuntos.push(document.getElementById(file[3]))
                })

                setOpenModalConfirm(false)
                setBoton1({icon: "fa fa-spinner fa-spin", text: "Enviando", disabled: true})
                sendNewMail (adjuntos, correosSelect.value, destEmail, destinatarios, asunto, contentState, (resp) => {respSend(resp)})
            }}
            funcion2 = {() => {
                setOpenModalConfirm(false)
                setBoton1({icon: "fa fa-send", text: "Enviar", disabled: false})
            }}
        />
    )

    return (
        <React.Fragment>
            <Row style={{paddingLeft: 10, paddingRight: 10}}>
                <div className="custom-alert-info" style={{backgroundColor:"fff", minHeight: 45, boxShadow:"2px 2px 4px #CCC", padding: 5}}>
                    <Row>
                        <Col md={7}>
                            <div><i title="Volver" onClick={()=> {props.funcion()}} className="fa fa-arrow-circle-left" style={styles2}></i> <strong>Nuevo Mensaje</strong></div>
                            <div className="text-muted" style={{fontSize: 12, paddingLeft: 22}}>{remitente()}</div>
                        </Col>
                        <Col md={5}>
                            <Select
                                isSearchable ={true}
                                isLoading = {correosLoad}
                                value={correosSelect}
                                onChange={cambiaCorreo}
                                options={correos}
                            />
                        </Col>
                    </Row>
                </div>
            </Row>
            <Row className="custom-mt-10" style={{left: 15, right: 15, position:"absolute", backgroundColor:"fff",
                height: "57vh", overflowY: "auto", overflowX: "hidden", borderTop: "1px solid #ededed", borderBotton: "1px solid #ededed"}}>
                <Col md={9} className="custom-mt-10">
                    {contenidoMail()}
                </Col>
                <Col md={3} className="custom-mt-10" style={{paddingLeft: 0}}>
                    <div style={{backgroundColor:"f2f4f8", boxShadow:"inset 2px 2px 1px #CCC", borderRadius:"4px 4px", padding: 5}}>
                        <div align="center" style={{height: "42vh", overflowY: "auto", overflowX: "hidden"}}>
                            <button className="btn btn-default" onClick={() => {addAttachment((Math.random() * 999999) + 1, (resp) => { addAttState(resp) })}} style={{borderWidth: 0, marginBottom: 5}} title="Haz click aqui para adjuntar un archivo"><i className={boton2.icon}></i> {boton2.text}</button>
                            <div id="attachments"></div>
                            <div style={{borderTop: "1px solid #ccc", paddingTop: 5}} align="left">{adjuntos()}</div>
                        </div>
                        <div style={{fontSize: 10, paddingTop: 4, borderTop: "1px solid #ccc"}} align="right"><strong>Total ({formatBytes(tam)})</strong></div>
                    </div>
                    <div className="custom-mt-10" align="right">
                        <button className="btn btn-primary" disabled={boton1.disabled} onClick = { sendMess } style={{borderWidth: 1}}><i className={boton1.icon}></i> {boton1.text}</button>
                    </div>
                </Col>
            </Row>
            {modalConfirm()}
        </React.Fragment>
    )
}

export default NewEmail;


// WEBPACK FOOTER //
// ./src/views/Email/NewEmail.jsx